function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.25 9.291h1.607V7.684c0-.71.017-1.803.517-2.48C10.901 4.487 11.624 4 12.869 4c2.027 0 2.881.297 2.881.297l-.402 2.451s-.67-.2-1.294-.2c-.625 0-1.185.231-1.185.874v1.87h2.563l-.179 2.393h-2.384V20H9.857v-8.315H8.25V9.29z",
    clipRule: "evenodd"
  }));
};
export default SvgIconFacebook;